import { render, staticRenderFns } from "./SidebarAddNewCommodity.vue?vue&type=template&id=5da7c856&"
import script from "./SidebarAddNewCommodity.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewCommodity.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewCommodity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports